module.exports = __webpack_public_path__ + "img/tema-1-5.2bea6cc7.svg";